<template>
  <div>
    <b-container>
      <b-row class="mt-md-5 ml-md-5">
        <b-col class="mt-2 mt-md-5 ml-md-5">
          <h4>Willkommen beim Standrohrverleihservice der evm.</h4>
        </b-col>
      </b-row>

      <b-row class="ml-md-5">
        <b-col class="mt-5 ml-md-5">
          <b>Bankverbindung/SEPA-Lastschrift-Mandat:</b>
        </b-col>
      </b-row>
      <b-row class="ml-md-5">
        <b-col class="mt-1 col-md-8 col-lg-6 ml-md-5">
          Für die Rückerstattung der Kaution bzw. des vertraglichen Überschusses und die Belastung von etwaigen Schäden am Standrohr und der Plombe.
        </b-col>
      </b-row>
      <b-row class="ml-md-5">
        <b-col class="ml-md-5 col-9 col-md-4 col-lg-3 mt-3 mt-md-2">
          <label for="iban" class="label">IBAN</label>
          <b-input
            id="iban"
            ref="iban"
            type="text"
            v-model="iban"
            :state="stateIban"
            aria-describedby="iban-feedback"
            @keyup.enter="save()"
            maxlength="32"
            @change="validateIban()">
          </b-input>
          <b-form-invalid-feedback id="iban-feedback">
            {{msgIban}}
          </b-form-invalid-feedback>
        </b-col>
        <b-col class="ml-md-2 col-9 col-md-4 col-lg-3 mt-3 mt-md-2">
          <label for="bic" class="label">BIC</label>
          <b-input
            id="bic"
            ref="bic"
            type="text"
            v-model="bic"
            :state="stateBic"
            aria-describedby="bic-feedback"
            @keyup.enter="save()"
            maxlength="11"
            :disabled="bankDisabled">
          </b-input>
          <b-form-invalid-feedback id="bic-feedback">
            {{msgBic}}
          </b-form-invalid-feedback>
        </b-col>
      </b-row>

      <b-row class="ml-md-5">
        <b-col class="col-9 col-md-4 col-lg-3 ml-md-5 mt-3 mt-md-2">
          <label for="bank" class="label">Bank</label>
          <b-input
            id="bank"
            ref="bank"
            type="text"
            v-model="bank"
            :state="stateBank"
            aria-describedby="bank-feedback"
            @keyup.enter="save()"
            maxlength="100"
            :disabled="bankDisabled">
          </b-input>
          <b-form-invalid-feedback id="bank-feedback">
            {{msgBank}}
          </b-form-invalid-feedback>
        </b-col>
      </b-row>
      <b-row class="ml-md-5">
        <b-col class="mt-4 ml-md-5">
          <b>Zahlungsabwicklung:</b>
        </b-col>
      </b-row>
      <b-row class="mt-3 mt-md-3 ml-md-5">
        <b-col class="col-9 col-md-4 col-lg-3 ml-md-5 mt-3 mt-md-2">
          <label for="paymentMethod" class="label">Zahlungsweise</label>
          <b-form-select
            id="paymentMethod"
            name="paymentMethod"
            v-model="selectedPaymentMethod"
            :options="paymentMethods"
            aria-describedby="paymentMethod-feedback"
            @keyup.enter="save()"
            :state="statePaymentMethod">
          </b-form-select>
          <b-form-invalid-feedback id="paymentMethod-feedback">
            {{msgPaymentMethod}}
          </b-form-invalid-feedback>
        </b-col>
        <b-col class="ml-md-2 col-9 col-md-4 col-lg-3 mt-3 mt-md-2">
          <label for="deposit" class="label">Kaution</label>
          <b-input
            id="deposit"
            ref="deposit"
            type="text"
            value="250 €"
            disabled>
          </b-input>
        </b-col>
      </b-row>
      <b-row class="ml-md-5" v-if="selectedPaymentMethod === 'bar'">
        <b-col class="col-9 col-md-4 col-lg-3 ml-md-5 mt-3 mt-md-2">
          <label for="contactType" class="label">Kontaktart</label>
          <b-form-select
            id="contactType"
            name="contactType"
            v-model="selectedContactType"
            :options="contactTypes"
            aria-describedby="contactType-feedback"
            @keyup.enter="save()"
            :state="stateContactType"
            @change="changeQualifier">
          </b-form-select>
          <b-form-invalid-feedback id="paymentMethod-feedback">
            {{msgPaymentMethod}}
          </b-form-invalid-feedback>
        </b-col>
        <b-col class="ml-md-2 col-9 col-md-4 col-lg-3 mt-3 mt-md-2">
          <label for="contact" class="label">{{ contactKind}}</label>
          <b-input
            id="contact"
            ref="contact"
            type="text"
            v-model="contact"
            :state="stateContact"
            aria-describedby="contact-feedback"
            @keyup.enter="save()"
            maxlength="100">
          </b-input>
          <b-form-invalid-feedback id="contact-feedback">
            {{msgContact}}
          </b-form-invalid-feedback>
        </b-col>
      </b-row>
      <b-row class="mt-2 mt-md-3 ml-md-5">
        <b-col class="col-9 ml-md-5">
          <b-form-checkbox
            id="terms"
            v-model="terms"
            name="terms"
            value="accepted"
            unchecked-value="not_accepted"
            :state="stateTerms"
            @keyup.enter="save()"
          >
            Ich akzeptiere die <a href="https://www.energienetze-mittelrhein.de/enm/Homepage/Datenschutz/" class="text-evm-orange-regular" target="_blank">Datenschutzerklärung</a>.
          </b-form-checkbox>
          <div v-if="msgTerms" class="text-danger" style="font-size: 80%">
            {{msgTerms}}
          </div>
        </b-col>
      </b-row>
      <b-row class="ml-md-5 mt-3" v-if="msgError">
        <b-col class="ml-md-2 ml-md-5 text-danger">{{msgError}}&nbsp;</b-col>
      </b-row>
      <b-row class="ml-md-5 mt-3">
        <b-col class="col-9 col-md-4 col-lg-3 ml-md-5 mt-3 mt-md-2">
          <div>Schritt 3 von 3</div>
        </b-col>
        <b-col class="ml-md-2 col-9 col-md-4 col-lg-3 mt-3 mt-md-2" >
          <b-container class="no-gutters p-0">
            <b-row class="no-gutters ">
              <b-col class="d-flex flex-row">
                <b-button
                  class="ml-md-auto"
                  @click="back()"
                >
                  Zurück
                </b-button>
              </b-col>
              <b-col class="d-flex flex-row">
                <b-button
                  class="ml-md-auto"
                  @click="save()"
                >
                  Bestellen
                </b-button>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
      <b-row class="mt-5">
        <b-col>&nbsp;</b-col>
      </b-row>
    </b-container>

    <cookie-consent
      message="Unsere Webseite verwendet Cookies. Informationen zu den verwendeten Cookies und weitere datenschutzrechtliche Hinweise finden Sie in unseren"
      linkLabel="Datenschutzhinweisen."
      href="https://www.evm.de/evm/Homepage/Impressum/#datenschutz"
      buttonLabel="Akzeptieren"
    />
  </div>
</template>

<script>

import { ApiCalls } from '@/scripts/ApiCalls'
import $ from 'jquery'

export default {
  name: 'StandrohrStart',
  components: {},
  data () {
    return {
      selectedCustType: null,
      iban: '',
      stateIban: null,
      msgIban: '',
      bic: '',
      stateBic: null,
      msgBic: '',
      bank: '',
      stateBank: null,
      msgBank: '',
      selectedPaymentMethod: null,
      statePaymentMethod: null,
      msgPaymentMethod: '',
      paymentMethods: [
        { value: null, text: 'Bitte Zahlungsweise wählen.', disabled: true },
        { value: 'PAYPAL', text: 'PayPal' },
        // { value: 'SU', text: 'Sofortüberweisung' },
        { value: 'bar', text: 'Barzahlen.de' }
      ],
      selectedContactType: 'email',
      contactTypes: [
        { value: 'email', text: 'E-Mail' },
        { value: 'fon', text: 'SMS' }
      ],
      stateContactType: null,
      msgContactType: '',
      contact: null,
      stateContact: null,
      msgContact: '',
      contactKind: 'E-Mail-Adresse',
      terms: null,
      stateTerms: null,
      msgTerms: '',
      msgError: '',
      publicPath: process.env.BASE_URL,
      bankDisabled: true,
      isConnectionError: false
    }
  },
  created () {
    if (localStorage.customerId) {
      this.msgError = ''
      this.contact = localStorage.mail

      this.selectedCustType = localStorage.selectedCustType
      if (localStorage.iban) {
        this.iban = localStorage.iban
      }
      if (localStorage.bic) {
        this.bic = localStorage.bic
      }
      if (localStorage.bank) {
        this.bank = localStorage.bank
      }
      if (localStorage.paymentMethod) {
        this.selectedPaymentMethod = localStorage.paymentMethod
      }
      if (localStorage.contactType) {
        this.selectedContactType = localStorage.contactType
      }
      if (localStorage.paymentContact) {
        this.contact = localStorage.paymentContact
      }
      if (localStorage.paymentContactKind) {
        this.contactKind = localStorage.paymentContactKind
      }
      if (localStorage.terms) {
        this.terms = localStorage.terms
      }
    } else {
      this.$router.replace({ name: 'standrohrStart' })
    }
  },
  methods: {
    saveLocal () {
      localStorage.iban = this.iban
      localStorage.bic = this.bic
      localStorage.bank = this.bank
      localStorage.paymentMethod = this.selectedPaymentMethod
      localStorage.contactType = this.selectedContactType
      localStorage.paymentContact = this.contact
      localStorage.paymentContactKind = this.contactKind
    },
    changeQualifier () {
      if (this.selectedContactType === 'fon') {
        this.contactKind = 'Mobilnummer'
        if (!this.contact || this.contact.includes('@')) {
          this.contact = localStorage.fon
        }
      } else {
        this.contactKind = 'E-Mail-Adresse'
        if (!this.contact || !this.contact.includes('@')) {
          this.contact = localStorage.mail
        }
      }
    },
    back () {
      this.saveLocal()
      this.$router.replace({ name: 'standrohr-2' })
    },
    validateIban () {
      let url = 'https://openiban.com/validate/' + this.iban
      let self = this
      this.iban = this.iban.split(' ').join('')
      $.ajax({
        url: url,

        data: {
          'validateBankCode': true,
          'getBIC': true
        },
        success: function (data) {
          let result = data
          console.log(result)
          if (result.valid) {
            console.log(result.bankData.bic)
            self.bic = result.bankData.bic
            self.bank = result.bankData.name
            self.msgIban = ''
            self.stateIban = null
          } else {
            self.msgIban = 'Ungültige IBAN'
            self.stateIban = false
          }
        },
        error: function (xhr) {
          console.error(xhr)
          self.bankDisabled = false
          self.msgError = 'IBAN kann nicht aufgelöst werden, bitte BIC und Bankname manuell eingeben.'
        }
      })
    },
    save () {
      let url = 'https://openiban.com/validate/' + this.iban
      let self = this
      this.iban = this.iban.split(' ').join('')
      $.ajax({
        url: url,

        data: {
          'validateBankCode': true,
          'getBIC': true
        },
        success: function (data) {
          let result = data
          console.log(result)
          if (result.valid) {
            console.log(result.bankData.bic)
            self.bic = result.bankData.bic
            self.bank = result.bankData.name
            self.validateAndSave()
          } else {
            self.msgIban = 'Ungültige IBAN'
            self.stateIban = false
          }
        },
        error: function (xhr) {
          console.error(xhr)
          self.bankDisabled = false
          self.isConnectionError = true
          self.validateAndSave()
        }
      })
    },
    validateAndSave () {
      let save = true

      this.saveLocal()
      this.msgError = ''
      if (!this.iban) {
        this.msgIban = 'Bitte IBAN eingeben.'
        this.stateIban = false
        save = false
      } else {
        this.msgIban = ''
        this.stateIban = null
        if (!/[0-9A-Z]{15,32}/i.test(this.iban)) {
          this.msgIban = 'Ungültige IBAN'
          this.stateIban = false
          save = false
        }
      }

      if (!this.bic) {
        this.msgBic = 'Bitte BIC eingeben.'
        this.stateBic = false
        if (this.isConnectionError) {
          this.msgError = 'IBAN kann nicht aufgelöst werden, bitte BIC und Bankname manuell eingeben.'
        }
        save = false
      } else {
        this.msgBic = ''
        this.stateBic = null
        if (!/[0-9A-Z]{8,11}/i.test(this.bic)) {
          this.msgBic = 'Ungültige BIC'
          this.stateBic = false
          if (this.isConnectionError) {
            this.msgError = 'IBAN kann nicht aufgelöst werden, bitte BIC und Bankname manuell eingeben.'
          }
          save = false
        }
      }

      if (!this.bank) {
        this.msgBank = 'Bitte Bank eingeben.'
        this.stateBank = false
        if (this.isConnectionError) {
          this.msgError = 'IBAN kann nicht aufgelöst werden, bitte BIC und Bankname manuell eingeben.'
        }
        save = false
      } else {
        this.msgBank = ''
        this.stateBank = null
        if (!/^[\p{L}\w &,.'\-+()/]+$/u.test(this.bank)) {
          this.msgBank = 'Der Name der Bank enthält ungültige Zeichen. Erlaubt sind Zahlen, Buchstaben und Zeichen wie ,.+\'-&()/'
          this.stateBank = false
          if (this.isConnectionError) {
            this.msgError = 'IBAN kann nicht aufgelöst werden, bitte BIC und Bankname manuell eingeben.'
          }
          save = false
        }
      }

      if (!this.selectedPaymentMethod) {
        this.msgPaymentMethod = 'Bitte Zahlungsweise auswählen.'
        this.statePaymentMethod = false
        save = false
      } else {
        this.msgPaymentMethod = ''
        this.statePaymentMethod = null
      }

      if (this.selectedPaymentMethod === 'bar') {
        if (!this.contact) {
          this.stateContact = false
          this.msgContact = 'Bitte ' + this.contactKind + ' eingeben.'
          save = false
        } else {
          this.stateContact = null
          this.msgContact = ''
          if (this.selectedContactType === 'email') {
            // eslint-disable-next-line no-control-regex
            let regexMail = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
            if (!regexMail.test(this.contact)) {
              this.msgContact = 'Ungültige E-Mail-Adresse'
              this.stateContact = false
              save = false
            }
          } else {
            if (!/^[\d+]{7,30}$/i.test(this.contact)) {
              this.msgContact = 'Ungültige Mobilnummer'
              this.stateContact = false
              save = false
            }
          }
        }
      }
      if (!this.terms || this.terms === 'not_accepted') {
        this.msgTerms = 'Bitte AGB und Datenschutzrichtlinien akzeptieren.'
        this.stateTerms = false
        save = false
      } else {
        this.msgTerms = ''
        this.stateTerms = null
      }
      if (save) {
        this.saveLocal()
        ApiCalls.safeThirdForm(localStorage.customerId, this.iban, this.bic, this.bank, this.selectedPaymentMethod,
          this.selectedContactType, this.contact).then(res => {
          console.log(res)
          if (res === 'OK') {
            this.$router.push({ name: 'callback' })
          } else if (res.startsWith('http')) {
            window.location = res
          } else {
            this.msgError = 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.'
          }
        }).catch(error => {
          console.log(error)
          this.msgError = 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.'
        })
      }
    }
  }
}
</script>

<style lang="css">

  .btn-evm-orange {
    background-color: rgb(243, 145, 0);
    border-color: rgb(243, 145, 0);
  }

  .btn-evm-orange:hover {
    background-color: rgb(243, 145, 0);
    border-color: rgb(243, 145, 0);
  }

  .form-control {
    padding-right: 1px !important;
    padding-left: 5px !important;
  }
</style>

<style lang="scss">
  /*
    CookieConsent
  */
  @import "../../scss/cookie-consent";
  @import "../../scss/cookie-consent-bottom";
  @import "../../scss/cookie-consent-transition";
  /*
    Bootstrap
  */
  @import "~bootstrap/scss/bootstrap";
</style>
